export enum StateType {
	INITIAL=0,
	QUESTIONS,
	SIGN_UP,
	CALL_TIME,
	SELECTION,
	FORM,
	RESULT,
	FINAL,
	NULL
}